<template>
  <li
    :class="{bold: isFolder}"
    @dblclick="changeType"
  >
    <span v-if="isFolder" @click="toggle">[{{ open ? '-' : '+' }}]</span>
    <span v-if="!edit" v-on:click="edit = true">{{ model.spaceCd }}</span>
    <input type="text" v-if="edit" v-model="model.spaceCd" v-on:blur="edit = false">
    <ul v-show="open" v-if="isFolder">
      <dd-tree
        class="item"
        v-for="(model, index) in model.childrenBomSpaceModel"
        :key="index"
        :model="model">
      </dd-tree>
      <li class="item" @click="addChild">+</li>
    </ul>
  </li>
</template>

<script>
import Tree from './Tree'
export default {
  name: 'dd-tree',
  components: {
    'dd-tree': Tree
  },
  props: {
    model: Object
  },
  data: function () {
    return {
      open: false,
      edit: false
    }
  },
  computed: {
    isFolder: function () {
      return this.model.childrenBomSpaceModel &&
      this.model.childrenBomSpaceModel.length
    }
  },
  methods: {
    toggle: function () {
      if (this.isFolder) {
        this.open = !this.open
      }
    },
    changeType: function () {
      if (!this.isFolder) {
        this.$set(this.model, 'childrenBomSpaceModel', [])
        this.addChild()
        this.open = true
      }
    },
    addChild: function () {
      this.model.childrenBomSpaceModel.push({
        // name: 'new stuff'
      })
    }
  }
}
</script>
<style scoped>
body {
font-family: Menlo, Consolas, monospace;
color: #444;
}
.item {
cursor: pointer;
}
.bold {
font-weight: bold;
}
ul {
padding-left: 67px;
padding-top: 10px;
list-style-type: dot;
}
li {
margin: 0;
padding: 11px 15px;
position: relative;
list-style: none;
}
li:after, li:before {
content: '';
left: -24px;
position: absolute;
right: auto;
}
li:before {
border-left: 1px dashed #999;
bottom: 50px;
height: 100%;
top: -14px;
width: 1px;
}
li:after {
border-top: 1px dashed #999;
height: 20px;
top: 22px;
width: 47px
}
ul>li:last-child::before {
height: 35px
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/admin/Tree.vue